import { useQuery } from '@tanstack/react-query';
import type { SubscriptionSummary, PlanSummary } from '@trackflow/shared';
import { api } from '../../lib/api';

export const SUBSCRIPTION_KEY = ['subscription'] as const;

export function useSubscription() {
  return useQuery({
    queryKey: SUBSCRIPTION_KEY,
    queryFn: () => api<SubscriptionSummary>('/subscription'),
  });
}

export function usePlans() {
  return useQuery({
    queryKey: ['plans'],
    queryFn: () => api<{ data: PlanSummary[] }>('/plans'),
    staleTime: 10 * 60_000,
  });
}
